import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContext, useMemo, useState } from "react";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Box } from "../../../../../Box/index.js";
import { InputTooltip } from "../../../../../InputTooltip/index.js";
import { List, ListItem } from "../../../../../List/index.js";
import { TextInput } from "../../../../index.js";
import { useForm } from "../../hooks/index.js";
import { WysiwygContext } from "../../../context/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const AddVideoDialog = ({ open, onClose, addVideo })=>{
    const [src, setSrc] = useState('');
    const [description, setDescription] = useState('');
    const validator = useValidationService();
    const { envVars } = useContext(WysiwygContext);
    const allValues = useMemo(()=>({
            src
        }), [
        src
    ]);
    const fieldValidators = useMemo(()=>({
            src: [
                validator.required(),
                validator.validUrl(),
                (value)=>{
                    if (!value) return;
                    try {
                        const { hostname } = new URL(value);
                        if ('rutube.sport' === hostname || hostname.endsWith('.rutube.sport')) return 'Добавление видео с rutube.sport не поддерживается';
                    } catch (unused) {}
                }
            ]
        }), [
        validator
    ]);
    const { errors, touched, validateField, hasValidationErrors, showError, handleBlur } = useForm(allValues, fieldValidators);
    const handleChangeSrcInput = (value_0)=>_async_to_generator(function*() {
            setSrc(()=>value_0 || '');
            yield validateField('src', value_0);
            showError('src');
        })();
    const handleChangeDescriptionInput = (value_1)=>{
        setDescription(()=>value_1 || '');
    };
    const handleSubmit = ()=>{
        onClose();
        addVideo(src, description);
    };
    return /*#__PURE__*/ jsx(Dialog, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ jsx("form", {
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ jsx(DialogContent, {
                title: "Добавление видео по ссылке",
                onClose: onClose,
                actions: /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(Button, {
                            variant: "tertiaryLight",
                            size: "large",
                            onClick: onClose,
                            children: "Отменить"
                        }),
                        /*#__PURE__*/ jsx(Button, {
                            type: "submit",
                            variant: "primary",
                            size: "large",
                            disabled: hasValidationErrors,
                            children: "Добавить"
                        })
                    ]
                }),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    gap: "24",
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body1",
                            color: "text.light.secondary",
                            children: "После добавления ссылки видео будет отображаться и воспроизводиться в полном размере"
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8",
                            children: [
                                /*#__PURE__*/ jsx(TextInput, {
                                    required: true,
                                    name: "src",
                                    label: "Ссылка на видео",
                                    placeholder: "Адрес ссылки",
                                    onChange: handleChangeSrcInput,
                                    error: touched.src && !!errors.src,
                                    helperText: touched.src ? errors.src : void 0,
                                    onBlur: handleBlur('src'),
                                    tooltip: /*#__PURE__*/ jsx(InputTooltip, {
                                        description: "Доступные платформы для добавления ссылки на видео:",
                                        children: /*#__PURE__*/ jsxs(Box, {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "12",
                                            children: [
                                                /*#__PURE__*/ jsx(List, {
                                                    pl: 2,
                                                    listStyleType: "disc",
                                                    children: /*#__PURE__*/ jsxs(Box, {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "8",
                                                        children: [
                                                            /*#__PURE__*/ jsx(ListItem, {
                                                                children: "VK Видео"
                                                            }),
                                                            /*#__PURE__*/ jsx(ListItem, {
                                                                children: 'Rutube (кроме домена rutube.sport)'
                                                            })
                                                        ]
                                                    })
                                                }),
                                                envVars.allowDirectVideoLinks && /*#__PURE__*/ jsx(Typography, {
                                                    variant: "caption",
                                                    color: "bg.light.primary",
                                                    children: "Доступно добавление прямой ссылки на видео"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ jsx(TextInput, {
                                    name: "description",
                                    label: "Подпись",
                                    placeholder: "Подпись к видео",
                                    onChange: handleChangeDescriptionInput
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
export { AddVideoDialog };
